import React from "react";
import ReactApexChart from "react-apexcharts";

export default class CChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coptions: {
        chart: {
          width: "100%",  // Make the chart take the full width of the container
          type: this.props.type || "pie", // Default to "pie" chart type
        },
        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"], // Alternating row colors for the grid
          },
        },
        legend: {
          show: true,  // Ensure the legend is visible
          position: "bottom",  // Position the legend at the bottom
          horizontalAlign: "center",  // Center the legend horizontally
          height: "2rem",  // Using rem for the height of the legend
          fontSize: "12rem", // Set font size of legend text
          itemMargin: {
            horizontal: 10, // Add margin between items
            vertical: 5,    // Add margin vertically
          },
        },
        labels: this.props.categories, // Use categories passed as props
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
      },
    };
  }

  render() {
    return (
      <div id="chart" style={{ width: "100%" }}>
        <ReactApexChart
          options={this.state.coptions}
          series={this.props.seriesData}  // Use seriesData passed as props
          type={this.props.type}          // Use chart type passed as props
          height="400px"                  // Use rem for the height of the chart (adjust as needed)
        />
      </div>
    );
  }
}
